<div class="side-menu-container" click-stop-propagation (clickOutside)="onClose()">
    <div class="side-menu-group" *ngFor="let items of menuItems;trackBy: trackByFn">
        <ng-container *ngFor="let item of items;trackBy: trackByFn">
            <div class="side-menu-group__menu-item" *ngIf="!item.hidden"
                [ngClass]="{'side-menu-group__menu-item--ZSuite' : isZSuite}"
                (click)="item.functionName && this[item.functionName]()"
                [class.disabled] = "item.disabled"
                [routerLink]="item.link && !item.functionName ? item.link : null"
                [class.is-active]="isActiveRoute(item.link)" nbTooltip="{{item.title | translate}}"
                nbTooltipPlacement="right" [nbTooltipTrigger]="isZSuite ? nbTrigger['HINT'] : nbTrigger['NOOP']">
                <nb-icon *ngIf="item.icon !== 'shelf-icon'" [icon]="item.icon" size="small"></nb-icon>
                <svg *ngIf="item.icon === 'shelf-icon'" class="shelf-icon" version="1.1" id="Warstwa_1"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 24 24" xml:space="preserve">
                    <g>
                        <rect y="0" style="fill-opacity: 0" width="24" height="24" />
                        <path class="cls-1"
                            d="M20.3,9C20.3,9,20.3,9,20.3,9l0-4c0-1.1-0.9-2-2-2h-4c-1.1,0-2,0.9-2,2v4h-0.6V5c0-1.1-0.9-2-2-2h-4c-1.1,0-2,0.9-2,2v4 c0,0,0,0,0,0C3.3,9.2,3,9.5,3,10V10c0,0.5,0.4,1,1,1h1.8h4h4.6h4H20c0.5,0,1-0.4,1-1V10C21,9.5,20.7,9.2,20.3,9z M5.7,9V5h4v4H5.7z M14.3,9V5h4v4H14.3z" />
                        <path class="cls-1"
                            d="M20.3,19C20.3,19,20.3,19,20.3,19l0-4c0-1.1-0.9-2-2-2h-4c-1.1,0-2,0.9-2,2v4h-0.6v-4c0-1.1-0.9-2-2-2h-4c-1.1,0-2,0.9-2,2 v4c0,0,0,0,0,0C3.3,19.2,3,19.5,3,20V20c0,0.5,0.4,1,1,1h1.8h4h4.6h4H20c0.5,0,1-0.4,1-1V20C21,19.5,20.7,19.2,20.3,19z M5.7,19v-4 h4v4H5.7z M14.3,19v-4h4v4H14.3z" />
                    </g>
                </svg>
                <span *ngIf="!isZSuite" class="menu-item__text">
                    {{item.title | translate}}
                </span>
            </div>
        </ng-container>
    </div>
</div>